// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__7Nspf","medium":"styles_medium__vIGCu","small":"styles_small__pZ9lA","overlay":"styles_overlay__fY7Ec","container":"styles_container__NgQ6B"};